<template>
  <div>
    <particlesHeader :Title="'Latest Achievements'" :Size="13" />
    <section class="content-section">
      <div class="container">
        <div class="row">
          <div
            class="col-lg-5 col-md-6 col-sm-12 centered works-box slizer-box"
            @click="$router.push('/theater/slizer')"
          >
            <achievmentCard
              :Title="'Slizer.js'"
              :Image="require('@/assets/works/slizer.png')"
              :Text="`Slizer.js is a javascript plugin to add a panoramic backgrounds to websites and pages, it
                      constantly changes the background position of the target element`"
            />
          </div>

          <div
            class="col-lg-5 col-md-6 col-sm-12 centered works-box"
            @click="GoExternal('http://isjse.org/');"
          >
            <achievmentCard
              :Title="'Solid Models'"
              :Image="require('../assets/works/solidModels.png')"
              :Text="`Solid Models™ is a company for medical CT/MRI scans
                      construction, it use those scans to generate a 3D models
                      Visualizing them for surgical Planning`"
            />
          </div>

          <div
            class="col-lg-4 col-md-6 col-sm-12 centered works-box"
            @click="$router.push('/theater/ytrack')"
          >
            <achievmentCard
              :Title="'Y Track'"
              :Image="require('../assets/works/ytrack_without_overlay.png')"
              :Text="` Y Track is a simple open-source tool that detect youtube browser videos and
                      capture them while watching`"
            />
          </div>

          <div
            class="col-lg-4 col-md-6 col-sm-12 centered works-box isjse-box"
            @click="GoExternal('http://www.solid-models.com/');"
          >
            <achievmentCard
              :Title="'ISJSE'"
              :Image="require('../assets/works/isjse_without_overlay.png')"
              :Text="`ISJSE™ is a global collection of a verious type of magazines ,
                      the website contains a portal for journals registration and
                      subscriptiong`"
            />
          </div>

          <div
            class="col-lg-4 col-md-6 col-sm-12 centered top-margined-30 works-box"
            @click="GoExternal('http://solid-models.com/software.php');"
          >
            <achievmentCard
              :Title="'Solid Extractor'"
              :Image="require('../assets/works/solidExtractor.png')"
              :Text="`Solid Extractor is tool meant to view dicom files in 2D world , the
                      puropse of this tool is to convert and compress dicom files
                      sequences
                      and upload them to solid model servers .`"
            />
          </div>
        </div>
      </div>
      <pageInlineNavigation :Next="'Tools'" :back="'Home'" />
    </section>
  </div>
</template>

<script>
import particlesHeader from "../components/particlesHeader";
import achievmentCard from "../components/achievmentCard";
import pageInlineNavigation from "../components/pageInlineNavigation";
export default {
  components: { particlesHeader, achievmentCard, pageInlineNavigation },

  data() {
    return {};
  },
  methods: {
    GoExternal: function (url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style>
.slizer-box .previous-project-box-image {
  margin-top: 0px !important;
}

.isjse-box .previous-project-box-image {
  margin-top: 44px !important;
}

.works-box {
  margin-top: 35px;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .previous-project-box:hover {
    background-color: initial;
    color: white;
  }
}
</style>